import { render, staticRenderFns } from "./RaPetLevelBar.vue?vue&type=template&id=2561d2b2&"
import script from "./RaPetLevelBar.vue?vue&type=script&lang=js&"
export * from "./RaPetLevelBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports